import {
  TARGET_TYPES,
  TARGET_TYPES_OPTIONS
} from '@/utils/constants/saleTargetConstants';

export const PRODUCT_GTIN_COLUMNS = [
  {
    name_of_db_column: 'position',
    label_of_column: 'POSITION',
    hideSortIcon: true,
    filterable: false
  },
  {
    name_of_db_column: 'gtin',
    label_of_column: 'GTIN',
    hideSortIcon: true,
    filterable: false
  }
];

export const isProductGroupQuantityType = (targetType) =>
  targetType === TARGET_TYPES.ProductGroupQuantity ||
  TARGET_TYPES_OPTIONS[targetType] === TARGET_TYPES.ProductGroupQuantity;

export const normalizeProductGtins = (productGtins) =>
  Array.isArray(productGtins) ? productGtins : [];

const slotValue = (item, index) => {
  const slot = Number(item?.slot);
  return Number.isFinite(slot) && slot > 0 ? slot : index + 1;
};

export const getProductGtinSlots = (productGtins = []) =>
  [...new Set(normalizeProductGtins(productGtins).map(slotValue))].sort(
    (a, b) => a - b
  );

export const toProductGtinRows = (productGtins = []) =>
  normalizeProductGtins(productGtins)
    .map((item, index) => ({
      slot: slotValue(item, index),
      gtin: item?.gtin ?? '',
      productId: item?.productId ?? '',
      productName: item?.productName ?? ''
    }))
    .sort((a, b) => a.slot - b.slot)
    .map((item) => ({
      position: `GTIN${item.slot}`,
      gtin: item.gtin,
      productId: String(item.productId),
      productName: item.productName
    }));
